import type { ComponentProps } from 'react';
import { AtlasThemeProvider } from '@diligentcorp/atlas-theme-mui';
import { createLensDataGridThemeOptions } from '@diligentcorp/atlas-theme-mui-data-grid/lib/index.js';

type ThemeExtensions = NonNullable<ComponentProps<typeof AtlasThemeProvider>['themeExtensions']>;

/**
 * Atlas theme extensions passed to every `<AtlasThemeProvider>`.
 *
 * The Data Grid theme is shipped as a separate Atlas package, so MUI X Data Grid
 * components only pick up Atlas styling and `theme.presets.DataGridPresets` when this
 * extension is registered. Both App.tsx and testUtils.tsx import this list so the app and
 * its tests always render the grid with the same theme.
 *
 * The cast bridges two copies of `@diligentcorp/atlas-design-tokens` in the tree
 * (`atlas-theme-mui` pins 0.27.x transitively, the app pins 0.31.5). The token objects
 * are structurally compatible at runtime for everything the Data Grid theme reads; only
 * the nominal `LensThemeTokens` declarations differ.
 */
export const atlasThemeExtensions: ThemeExtensions = [
  createLensDataGridThemeOptions as unknown as ThemeExtensions[number],
];
